// extracted by mini-css-extract-plugin
export default {"btn":"FiscalRegistrars_btn__Opmd+","rightTextElem":"FiscalRegistrars_rightTextElem__7-8yK","headerTextEnd":"FiscalRegistrars_headerTextEnd__bEo0Y"};